define(
    'providers/dataprovider.settings',[
        "services/config"
    ],
    function(config) {

        function getCategorySettings(categoryName) {
            var deferred = $.Deferred();
            amplify.request({
                resourceId: "get-category-settings",
                data: { category: categoryName },
                success: function (result, statusCode) { deferred.resolve(result, statusCode);},
                error: function (result, statusCode) { deferred.reject(result, statusCode); }
            });
            return deferred.promise();
        }

        function getSetting(settingName) {
            var deferred = $.Deferred();
            amplify.request({
                resourceId: "get-setting",
                data: { key: settingName },
                success: function (result, statusCode) { deferred.resolve(result, statusCode); },
                error: function (result, statusCode) { deferred.reject(result, statusCode); }
            });
            return deferred.promise();
        }

        function updateSetting(key, value) {
            var deferred = $.Deferred();
            amplify.request({
                resourceId: "update-setting",
                data: { key: key, value: value },
                success: function (result, statusCode) { deferred.resolve(result, statusCode); },
                error: function (result, statusCode) { deferred.reject(result, statusCode); }
            });
            return deferred.promise();
        }
        function updateSettingGuided(kvps) {
            var deferred = $.Deferred();
            amplify.request({
                resourceId: "update-setting-guided",
                data: kvps,
                success: function (result, statusCode) { deferred.resolve(result, statusCode); },
                error: function (result, statusCode) { deferred.reject(result, statusCode); }
            });
            return deferred.promise();
        }

        function getUsageSetting() {
            var deferred = $.Deferred();
            amplify.request({
                resourceId: "get-usage-settings",
                success: function (result, statusCode) { deferred.resolve(result, statusCode); },
                error: function (result, statusCode) { deferred.reject(result, statusCode); }
            });
            return deferred.promise();
        }

        function getPurgeSetting() {
            var deferred = $.Deferred();
            amplify.request({
                resourceId: "get-purge-settings",
                success: function (result, statusCode) { deferred.resolve(result, statusCode); },
                error: function (result, statusCode) { deferred.reject(result, statusCode); }
            });
            return deferred.promise();
        }

        function purgeDocuments(lastxday) {
            return $.Deferred(function (deferred) {
                if (lastxday == undefined) {
                    amplify.request({
                        resourceId: "delete-purge-documents",
                        success: function (result, statusCode) { deferred.resolve(result, statusCode); },
                        error: function (result, statusCode) { deferred.reject(result, statusCode); }
                    });
                } else {
                    amplify.request({
                        resourceId: "delete-purge-documents-by-id",
                        data: { lastxday: lastxday },
                        success: function (result, statusCode) { deferred.resolve(result, statusCode); },
                        error: function (result, statusCode) { deferred.reject(result, statusCode); }
                    });
                }
            }).promise();
        }

        function updateFooter(data) {            
            var deferred = $.Deferred();
            amplify.request({
                resourceId: "update-settings-footer",
                data: data,
                success: function (result, statusCode) { deferred.resolve(result, statusCode); },
                error: function (result, statusCode) { deferred.reject(result, statusCode); }
            });
            return deferred.promise();
        }

        function getFooter() {
            var deferred = $.Deferred();
            amplify.request({
                resourceId: "get-settings-footer",
                success: function (result, statusCode) { deferred.resolve(result, statusCode); },
                error: function (result, statusCode) { deferred.reject(result, statusCode); }
            });
            return deferred.promise();
        }

        init();

        return {
            getCategorySettings: getCategorySettings,
            getSetting: getSetting,
            updateSetting: updateSetting,
            updateSettingGuided: updateSettingGuided,
            getUsageSetting: getUsageSetting,
            getPurgeSetting: getPurgeSetting,
            purgeDocuments: purgeDocuments,
            updateFooter: updateFooter,
            getFooter: getFooter
        };

        //#region Internal Methods

        function init() {
            amplify.request.define("get-category-settings", "ajax", {
                url: getUrl("category/{category}"),
                dataType: "json",
                type: "GET"
            });

            amplify.request.define("get-setting", "ajax", {
                url: getUrl("{key}"),
                dataType: "json",
                type: "GET"
            });

            amplify.request.define("update-setting", "ajax", {
                url: getUrl("{key}"),
                dataType: "json",
                type: "PUT",
                dataMap: function (data) {
                    return data.value;
                }
            });

            amplify.request.define("update-setting-guided", "ajax", {
                url: getUrl("setupguide"),
                dataType: "json",
                type: "PUT",
                dataMap: function (data) {
                    return JSON.stringify(data);
                }
            });

            amplify.request.define("get-usage-settings", "ajax", {
                url: getUrlWithoutSettings("admin/adminsettings/usage"),
                dataType: "json",
                type: "GET"
            });

            amplify.request.define("get-purge-settings", "ajax", {
                url: getUrlWithoutSettings("admin/adminsettings/purge"),
                dataType: "json",
                type: "GET"
            });

            amplify.request.define("delete-purge-documents", "ajax", {
                url: getUrlWithoutSettings("admin/adminsettings/purge/deleted"),
                dataType: "json",
                type: "DELETE"
            });
            amplify.request.define("delete-purge-documents-by-id", "ajax", {
                url: getUrlWithoutSettings("admin/adminsettings/purge/deleted/{lastxday}"),
                dataType: "json",
                type: "DELETE"
            });

            amplify.request.define("update-settings-footer", "ajax", {
                url: getUrlWithoutSettings("documentshares/documentsharefooter"),
                dataType: "json",
                type: "PUT",
                dataMap: function (data) {                    
                    return data;
                }
            });
            amplify.request.define("get-settings-footer", "ajax", {
                url: getUrlWithoutSettings("documentshares/documentsharefooter"),
                dataType: "json",
                type: "GET"
            });
        }
        
        function getUrl(action) {
            return config.webApiUrl + "settings/" +  action;
        }

        function getUrlWithoutSettings(action) {
            return config.webApiUrl + action;
        }

        //#endregion
    }
);
